import type { ReactNode } from "react";

import { classes } from "./classes.js";
import { TONE_CLASSES, type Tone } from "./tone.js";

/**
 * `P0-UIK-001`. 4.6.3: `rounded-full` on chips, `text-xs` for metadata.
 *
 * The tone is a PROP and never derived: this component does not know what a
 * dossier is, and 9.3.1 is what keeps it that way.
 *
 * `KIT-WARN-BG`: the chip says its tone as a hook (`data-kit`, `data-tone`) so that the BANK's theme can ground the attention chip as D2 does
 * (`components.css:93`); the tone's own classes, which the other apps wear, are untouched.
 */
export interface ChipProps {
  readonly children: ReactNode;
  readonly tone?: Tone;
  readonly className?: string;
}

export function Chip({ children, tone = "neutre", className }: ChipProps): React.JSX.Element {
  return (
    <span
      data-kit="chip"
      data-tone={tone}
      className={classes(
        "whitespace-nowrap rounded-full px-2 py-1 text-xs font-medium",
        TONE_CLASSES[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
